import { DateTime } from "luxon"
import { CreditNote } from "@oysterhr/schema"

export const formatCreditNotePayrollMonth = (
  { month, year }: Pick<CreditNote, "month" | "year">,
  onEmpty = "-",
) =>
  month && year
    ? DateTime.fromObject({ month, year }).toLocaleString({ month: "long", year: "numeric" })
    : onEmpty
